import { render, staticRenderFns } from "./ClicInputMask.vue?vue&type=template&id=2b965e0a&"
import script from "./ClicInputMask.vue?vue&type=script&lang=js&"
export * from "./ClicInputMask.vue?vue&type=script&lang=js&"
import style0 from "./ClicInputMask.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports